
import { InjectionToken } from '@angular/core';

export const SINGLETON_SERVICE = new InjectionToken<any>('SINGLETON_SERVICE');
export const SCOPE_SERVICE = new InjectionToken<any>('SCOPE_SERVICE');
